<header>
	@if (showMainNav()) {
		<div class="meta-navigation">
			<div id="logo-name">
				<div class="logo-loggedin">
					<a routerLink="/workflow.do?from=menu&to=home"
					   tabindex="0">
						<img src="page/style/img/AZ_Logo_positive_RGB.png">
					</a>
				</div>
				<div class="vertical-line"></div>
				<div class="application-name-loggedin">
					{{'page.applicationName' | msgKey}}
				</div>
			</div>

			<nav id="icon-nav">
				<div class="amp-logo"
					 tabindex="0"
					 (keydown.enter)="triggerClick($event)">
					<a class="amp-logo"
					   tabindex="-1"
					   routerLink="/workflow.do?from=menu&to=home">
						<img src="page/style/img/amp-logo.svg"
							 id="amp-logo">
					</a>
				</div>
				<bas-fav-nav-icon (popoverOpened)="closeOtherNavIconPopovers($event)"></bas-fav-nav-icon>

				@for (altNavItem of altItems(); track altNavItem.id) {
					<bas-nav-icon [altNavItem]="altNavItem" (popoverOpened)="closeOtherNavIconPopovers($event)"></bas-nav-icon>
				}

				<div class="logout"
					 [pTooltip]="'image.metanav.logout.alt' | msgKey"
				     tooltipPosition="bottom"
				     tooltipEvent="both"
					 (keydown.enter)="triggerLogoutClick($event)">
					<a routerLink="/logout.do"
					   tabindex="-1"
					   (click)="logout()">
						<mat-icon svgIcon="allianz_logout"
								  class="default-icon"></mat-icon>
						<mat-icon svgIcon="allianz_logout_hover"
								  class="hover_icon"></mat-icon>
					</a>
				</div>
			</nav>

		</div>

		<nav>
			<div class="main-navigation primaryCiColor">
				<bas-nav-quick class="quick-nav"></bas-nav-quick>
				<ul>
					@for (topItems of items(); track topItems.id) {
						@if (topItems.name === 'root') {
							@for (item of topItems.children; track item.id) {
								<bas-nav-item [item]="item"></bas-nav-item>
							}
						} @else if (topItems.id === 'spacer') {
							@if (!$last) {
								<div class="vertical-line"></div>
							}
						} @else {
							<bas-nav-item [item]="topItems"></bas-nav-item>
						}
					}
				</ul>

				<div class="searchField"
					 [ngClass]="searchFieldClass"
					 tabindex="0"
					 (keydown.enter)="triggerClickOpenSearch($event)">
					<bas-nav-search-field (stateToEmit)="checkState($event)"></bas-nav-search-field>
				</div>
			</div>
		</nav>
	} @else {
		<div class="meta-navigation">
			<div id="logo-name">
				<div class="logo-loggedin">
					<img src="page/style/img/AZ_Logo_positive_RGB.png">
				</div>
				<div class="vertical-line"></div>
				<div class="application-name-loggedin">
					{{'page.applicationName' | msgKey}}
				</div>
			</div>

		</div>
	}
</header>